<template>
  <div class="city-info" :class="module.name">
    <div class="city-title" />
    <Guests v-if="module.guests && data.guests" :index="module.guests" :en="module.en" :data="data.guests" />
    <POSITION
      v-if="module.position && data.position"
      :index="module.position"
      :title="module.title"
      :name="module.name"
      :en="module.en"
      :data="data.position"
    />
    <SUMMARY v-if="module.summary" :index="module.summary" :title="module.title" :en="module.en" :data="data.summary" />
    <SEGMENT v-if="module.segment && data.timeLine" :index="module.segment" :en="module.en" :data="data.timeLine" />
    <ADDRESS
      v-if="module.address && data.address"
      :index="module.address"
      :en="module.en"
      :data="data.address"
      :city-name="cityName"
    />
    <div v-if="module.name === 'ip-index-module' && picList && picList.length > 0" class="ip-banner-wrapper">
      <div class="float-bg" />
      <poster-swiper :pic-list="picList"></poster-swiper>
    </div>
    <EXHIBITOR v-if="module.exhibitor" :index="module.exhibitor" :en="module.en" :data="data.webexhibitor" />
    <empty-info v-if="data && Object.keys(data).length === 0" :title="module.title" />
  </div>
</template>
<script>
import Guests from '../city/guests.vue'
import POSITION from '../city/position.vue'
import SUMMARY from '../city/summary.vue'
import SEGMENT from '../city/segment.vue'
import ADDRESS from '../city/address.vue'
import EXHIBITOR from '../city/exhibitor.vue'
import EmptyInfo from './empty.vue'

export default {
  components: {
    Guests,
    POSITION,
    SUMMARY,
    SEGMENT,
    ADDRESS,
    EXHIBITOR,
    EmptyInfo,
  },
  props: {
    module: {
      type: Object,
      default: () => {},
    },
    cityName: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
    picList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {},
}
</script>
<style lang="less">
.city-info {
  font-family: HYYakuHei55W;
  width: 100%;
  overflow: hidden;

  .city-title {
    position: relative;
    z-index: 2;
    width: 1090px;
    height: 125px;
    background-repeat: no-repeat;
    background-size: 765px auto;
    margin: 0 auto 65px;
    padding-right: 325px;
  }

  &.carnival-module {
    .city-title {
      background-image: url('~@/assets/carnival2020/title_carnival.png');
    }
  }

  &.concert-module {
    .city-title {
      background-image: url('~@/assets/carnival2020/title_concert.png');
    }
  }

  &.ip-index-module {
    .city-title {
      background-image: url('~@/assets/carnival2020/title_ip.png');
    }
  }
  .module_title {
    max-width: 1090px;
    margin: 0 auto;
    white-space: nowrap;
    position: relative;
    z-index: 3;
    text-align: center;
    white-space: nowrap;
    span {
      vertical-align: middle;
    }
    .num {
      display: inline-block;
      width: 96px;
      height: 32px;
      background-repeat: no-repeat;
      background-size: contain;
      &.num_1 {
        background-image: url('~@/assets/carnival2020/NO_1.png');
      }
      &.num_2 {
        background-image: url('~@/assets/carnival2020/NO_2.png');
      }
      &.num_3 {
        background-image: url('~@/assets/carnival2020/NO_3.png');
      }
      &.num_4 {
        background-image: url('~@/assets/carnival2020/NO_4.png');
      }
    }
    .en {
      font-size: 14px;
      font-family: HYYakuHei55W;
      color: #ffffff;
      line-height: 26px;
      letter-spacing: 20px;
      white-space: nowrap;
    }
    .tit {
      position: relative;
      font-size: 30px;
      margin-right: 20px;
      padding: 1px 2px;
      font-family: HYYakuHei55W;
      font-style: italic;
      text-align: center;
      color: #ceff1a;
      white-space: nowrap;
      &::before,
      &::after {
        position: absolute;
        display: inline-block;
        content: '';
        height: 1px;
        background: #ffffff;
        width: 100%;
      }
      &::before {
        top: 0;
        left: 8px;
      }
      &::after {
        bottom: 0;
        left: 0;
      }
    }
  }

  .ip-banner-wrapper {
    position: relative;
    width: 1072px;
    height: 254px;
    margin: 0 auto 80px;
    .frame-bg {
      background: transparent url('~@/assets/carnival2020/main-kv/swiper-container-green.png') center center no-repeat;
      background-size: cover;
    }
    .swiper-pagination {
      .swiper-pagination-bullet {
        &.swiper-pagination-bullet-active {
          background: transparent url('~@/assets/carnival2020/main-kv/pagination-bullet-green-act.png') center center
            no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
</style>
